import cn from 'classnames';

interface BestSellerWrapperProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  isMobile?: boolean;
  bestSellerLength: number;
  message?: React.ReactNode;
}

/**
 * Component to group bestseller products.
 * It is expected to used in the grid css
 */
const BestSellerWrapper: React.FC<
  React.PropsWithChildren<BestSellerWrapperProps>
> = ({
  children,
  isMobile = false,
  className,
  bestSellerLength,
  message,
  ...otherProps
}) => {
  /**
   * Remove Unsere from message and make best seller bold
   */
  let _message = message;
  if (_message && typeof _message === 'string') {
    const match = _message.match(/(.*?)(Unsere\s)?(Bestseller)(.*)/);

    if (match) {
      _message = (
        <>
          {match[1]}
          <span className={'font-mindset text-2xl  font-normal  tracking-wide'}>
            {match[3]}
          </span>
          {match[4]}
        </>
      );
    }
  }

  return (
    <div
      className={cn(
        `lg:col-span-${bestSellerLength}`,
        'relative left-1/2 right-1/2 -mx-[50vw] flex w-screen flex-col lg:static lg:mx-0 lg:w-auto'
      )}
    >
      <div
        className={cn(
          'w-full bg-badge-bestseller py-2',
          'lg:rounded-lg lg:px-2',
          className
        )}
        {...otherProps}
      >
        <div className="px-4 lg:px-0! lg:container">
          {message && (
            <span
              id="bestSellerWrapperMessage"
              className="inline-block px-2 mb-4 text-primary-main"
              data-test="bestseller-wrapper-message"
            >
              {_message}
            </span>
          )}
          <div
            className={cn(
              'grid grow gap-3 lg:gap-5',
              isMobile ? 'grid-cols-1' : `grid-cols-${bestSellerLength}`
            )}
            data-test="bestseller-wrapper-grid"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestSellerWrapper;
